/**
 * @generated SignedSource<<c15bb2cde67acce1502511b1b0a57797>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userRootNodeItem_RootNodesWithTreeStateTypeFragment$data = {
  readonly rootNode: {
    readonly " $fragmentSpreads": FragmentRefs<"createTreeStateButton_LearnOpportunityV2Fragment" | "reenablePaywallButton_LearnOpportunityV2Fragment" | "resetLearnProgressButton_LearnOpportunityV2Fragment" | "unlockTreeButton_LearnOpportunityV2Fragment" | "userRootNodeItem_LearnOpportunityV2Fragment">;
  } | null;
  readonly treeState: {
    readonly " $fragmentSpreads": FragmentRefs<"editLearnStartDateButton_TreeStateFragment" | "userRootNodeItem_TreeStateFragment">;
  } | null;
  readonly " $fragmentType": "userRootNodeItem_RootNodesWithTreeStateTypeFragment";
};
export type userRootNodeItem_RootNodesWithTreeStateTypeFragment$key = {
  readonly " $data"?: userRootNodeItem_RootNodesWithTreeStateTypeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userRootNodeItem_RootNodesWithTreeStateTypeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userRootNodeItem_RootNodesWithTreeStateTypeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnOpportunityV2",
      "kind": "LinkedField",
      "name": "rootNode",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userRootNodeItem_LearnOpportunityV2Fragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "reenablePaywallButton_LearnOpportunityV2Fragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "resetLearnProgressButton_LearnOpportunityV2Fragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "createTreeStateButton_LearnOpportunityV2Fragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "unlockTreeButton_LearnOpportunityV2Fragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeState",
      "kind": "LinkedField",
      "name": "treeState",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userRootNodeItem_TreeStateFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "editLearnStartDateButton_TreeStateFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RootNodesWithTreeStateType",
  "abstractKey": null
};

(node as any).hash = "cea9ad5ab6c2a07e737729b7a165662b";

export default node;
